import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _MandatoryMixin from '../../more/Legacy/Controls/_MandatoryMixin/_MandatoryMixin';
import template from './MultiSelectBox.html?raw';
// NOTE (JS2TS): the original define() imported "more/Controls/_MandatoryMixin/_MandatoryMixin" which does not
// exist (latent Linux-case/path bug) — repointed to the real git-tracked file at more/Legacy/Controls/... .
// Dropped dead deps (connect, array, Color, keys, dijit _WidgetBase/_TemplatedMixin/_WidgetsInTemplateMixin,
// registry, dijit form/TextBox/Button/ComboButton, Menu/MenuItem/Toolbar, request/xhr, dojox Standby, mouse, query).
// DOM-heavy → dom-construct aliased.
const domConstruct: any = domConstructTyped;

class MultiSelectBox extends compose(_WidgetBaseSP, _MandatoryMixin) {
    [key: string]: any;

    templateString: any = template;

    currentFocus: any = null;

    isEditModeActive = false;

    isShowSelectedMode = false;

    labelAttribute: any = null;
    valueAttribute = "ID"; // Vorgabewert
    suggestionLabelAttribute: any = null;
    filterPath: any = null;
    searchParam: any = null; // name des Parameters im Filter ( => pit-Filter)
    requestUrlParameter: any = null; // parametername für Extraparameter, der vom Controller erwartet wird
    requestUrlParameterValue: any = null; // wert des Extraparameters
    resetOnEdit = false; // das Entity zurücksetzen wenn der Benutzer eine Eingabe macht (also Inputfeld irgendwie reintippt)

    __request: any = null;
    __searchDelay: any = null;
    __confirmDelay: any = null;
    _plainvalue: any = null; // zum Vergleichen: was steht im Input nach der Entityauswahl und hat der Benutzer was reingetippt?

    _additionalParameters: any = [];

    entities: any = [];
    optionsRegistry: any = [];
    _selectedValues: any = [];
    _selectedEntities: any = [];
    _oldSelection: any = "-x"; // ändert sich auch wenn nach erstem Laden "nichts" gewählt ist

    url: any = null;

    limit = 10;
    dataformat = "json"; // wird für Request und Response benötigt (pithelper)
    readonly = false;

    selectablesWithDropdown = false;
    dropdownAttributeName: any = null;

    setRequestParameter(paramName: any, paramValue: any): void {
        if (this.requestUrlParameter == null || this.requestUrlParameter == paramName) {
            this.requestUrlParameter = paramName;
            this.requestUrlParameterValue = paramValue;
        } else if (lang.isArray(this.requestUrlParameter)) {
            for (var i = 0; i < this.requestUrlParameter.length; i++) {
                var param = this.requestUrlParameter[i];

                if (param == paramName) {
                    this.requestUrlParameterValue[i] = paramValue;
                    return;
                }
            }

            this.requestUrlParameter.push(paramName);
            this.requestUrlParameterValue.push(paramValue);
        } else if (this.requestUrlParameter != null) {
            // dann muss man erst ein Array draus machen
            var arrayNames = [this.requestUrlParameter];
            var arrayValue = [this.requestUrlParameterValue];

            arrayNames.push(paramName);
            arrayValue.push(paramValue);

            this.requestUrlParameter = arrayNames;
            this.requestUrlParameterValue = arrayValue;
        }
    }

    getRequestParameterValue(paramName: any, paramValue?: any): any {
        if (lang.isArray(this.requestUrlParameter)) {
            for (var i = 0; i < this.requestUrlParameter.length; i++) {
                var param = this.requestUrlParameter[i];

                if (param == paramName) {
                    return this.requestUrlParameterValue[i];
                }
            }
        } else if (this.requestUrlParameter == paramName) {
            return this.requestUrlParameterValue;
        }

        return -1;
    }

    _setPlaceholderAttr(value: any): void {
        domAttr.set(this.input, "placeholder", value);
    }

    _setReadonlyAttr(value: any): void {
        this.readonly = value !== false;

        var classFct1: any = domClass.add;
        var classFct2: any = domClass.remove;

        if (this.readonly == true) {
            classFct1 = domClass.remove;
            classFct2 = domClass.add;

            domAttr.set(this.outerInput, "disabled", "disabled");
            domAttr.set(this.input, "disabled", "disabled");

        } else {
            domAttr.remove(this.outerInput, "disabled");
            domAttr.remove(this.input, "disabled");
        }

        classFct2(this.outerInput, "w3-disabled");
        classFct2(this.openDropdownBtn, "w3-disabled");
        classFct1(this.openDropdownBtn, "mds-hover-dark");
    }

    _setMandatoryAttr(value: any): void {
        this.mandatory = value;
        //this.checkValidity();
    }

    _setEditModeAttr(bActive: any): void {
        if (this.readonly == true) {
            return;
        }

        if (bActive !== false) {
            bActive = true;
        }

        if (this.isEditModeActive != bActive) {
            this.isEditModeActive = bActive;
            this.setEditModeStyle();

            if (this.isEditModeActive == true) {
                // die bisherige Auswahl als Backup wegspeichern
                this._oldSelection = [];
                for (var i = 0; i < this._selectedValues.length; i++) {
                    this._oldSelection.push(this._selectedValues[i]);
                }

                //this.btnSelectNone.scrollIntoView({
                //    behavior: "smooth"
                //    //block: "end",
                //});
            } else {
                this._selectedValues = this._oldSelection;
                this.input.value = null;
                this._handleSearch();
            }
        }

        //console.log("_setEditModeAttr", bActive, this._selectedValues);
    }

    _setDataFormatAttr(value: any): void {

        if (value != "pit" && value != "json") {
            value = "json";
        }

        this.dataformat = value;

        this.PitHelper._structureFormat = this.dataformat;
    }

    _getValueAttr(bReturnEntities?: any): any {
        if (bReturnEntities === true) {
            return this._selectedEntities;
        }

        return this._selectedValues;
    }

    _setValueAttr(values: any): void {

        //console.log("multiselectbox _setValueAttr", values);
        this._selectedValues = [];

        if (values === true) { // alle wählen
            this.selectAll();
            return;
        }

        if (typeof (values) == "object") {
            if (lang.isArray(values)) {
                for (var i = 0; i < values.length; i++) {
                    this._selectedValues.push(values[i]);
                }
            }
            else {
                this._selectedValues.push(this.PitHelper.getEntityAttributeValue(values, this.valueAttribute));
            }
        } else if ((typeof (values) as any) == "text") { // JS2TS: original compares to "text" (never a valid typeof result) — latent bug preserved.
            this._selectedValues.push(values);
        }

        this._adjustSelectionStyle();
        this.updateCurrentSelectedValues();

    }

    buildListValues(options: any, presetValues: any): void {
        this._onLoadListValuesResponse(presetValues, options);
    }

    _loadListValues(presetValue?: any): void {

        // nicht resetten, evtl wird ein Wert gesetzt und die möglichen Werte danach nachgeladen
        //

        //console.log("multiselect _loadListValues", presetValue);

        if (typeof (presetValue) != "undefined") {
            //this.set("value", presetValue);
        }
        else {
            this._selectedValues = [];// = null;
            this._selectedEntities = [];
        }

        //this._adjustCurrentSelectionState();

        var url;
        if (this.url == null) {

        } else {
            url = this.url;
        }


        if (this.__request != null) {
            //console.log("selectbox: request cancel");
            this.__request.cancel();
            this.__request = null;
        }

        this.StandbyStart();

        var requestParams: any = {};

        if (this.filterPath != null) {
            requestParams.filterPath = this.filterPath;
        }

        if (this.searchParam != null) {
            requestParams.searchParam = this.searchParam;
        }

        if (this.limit != null) {
            requestParams.limit = this.limit;
        }

        requestParams.labelAttribute = this.labelAttribute;

        // Extraparameter
        if (this.requestUrlParameter != null) {
            if (lang.isArray(this.requestUrlParameter)) {
                for (var i = 0; i < this.requestUrlParameter.length; i++) {
                    var param = this.requestUrlParameter[i];
                    var value = this.requestUrlParameterValue[i];

                    requestParams[param] = value;
                }
            } else {
                requestParams[this.requestUrlParameter] = this.requestUrlParameterValue;
            }

        }

        var requestUrl = window.appRoot + url;

        //console.log("multiSelectBox _loadListValues", requestUrl, requestParams, presetValue);

        this.__request = this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, "_onLoadListValuesResponse", presetValue),
            lang.hitch(this, "_onLoadListValuesError"),
            false // sync
        );
    }

    _onLoadListValuesResponse(presetValue: any, response?: any): void { // responsecallback
        //console.log("multiSelectBox _onLoadListValuesResponse - response - preset", response, presetValue);
        this.__request = null;

        this.isShowSelectedMode = false;

        // ist entweder klassisches pit-Datarray oder json-Array aus API
        if (this.dataformat == "pit") {
            this.entities = response.EntityDataArray;
        } else if (this.dataformat == "json") {
            this.entities = response;
            if ((typeof (response) as any) == "text") { // Kompatibilität mit bisher doppelt stringifizierten JSON-Responses // JS2TS: "text" is never a valid typeof result — latent bug preserved.
                this.entities = JSON.parse(response);
            }
        }

        this._constructOptions();

        if (presetValue != null && typeof (presetValue) != "undefined") {
            this.set("value", presetValue);
            this.confirmSelection(false);
        }

        this.StandbyStop();

        //this._handleSearch();
    }

    _onLoadListValuesError(err: any): void { // errorCallback
        console.error("_onLoadListValuesError", err);
        this.__request = null;
        if (typeof (err) == "object") {
            alert(err.Message);
        } else {
            alert(err);
        }
        this.StandbyStop();
    }

    _constructOptions(bUpdateSelection?: any): void {
        domConstruct.empty(this.scrollContainer);

        this.optionsRegistry = [];
        //console.log("Multiselect _constructOptions", this._selectedValues, this.entities);

        var bOnlySelected = this.isShowSelectedMode == true;

        // aus den geladenen Daten die selects erstellen
        if (this.entities != null) {
            for (var i = 0; i < this.entities.length; i++) {
                var entity = this.entities[i];

                var value = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute);
                var label = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute);
                if (this.labelAttribute != "" && this.labelAttribute != null) {
                    label = this.PitHelper.getEntityAttributeValue(entity, this.labelAttribute);
                }

                var bShow = true;

                bShow = bOnlySelected != true || this._selectedValues.indexOf(value, 0) != -1;

                // wenn eine Suche eingetragen ist...
                if (this.input.value != false) {
                    if (label.toLowerCase().includes(this.input.value.toLowerCase(), 0)) {

                    }
                    else {
                        bShow = false;
                    }
                }


                var option = domConstruct.create("div", { className: "mds-hover-dark" }, this.scrollContainer);
                //domClass.add(option, "selectbox-items");
                domClass.add(option, "flex_row_center");

                if (bShow != true) {
                    domClass.add(option, "w3-hide");
                }

                var optionSelector = domConstruct.create("div", { innerHTML: "<i class='far fa-circle' aria-hidden='true'></i>" }, option);
                domClass.add(optionSelector, "w3-padding-small");

                var optionLabel = domConstruct.create("div", { innerHTML: label, style: { "flex": "1" } }, option);
                domClass.add(optionLabel, "w3-padding-small");


                if (this.selectableAttribute != null && this.PitHelper.getEntityAttributeValue(entity, this.selectableAttribute) != true) {
                    // Eintrag ist nicht selektierbar!
                    domClass.remove(option, "mds-hover-dark");
                    domClass.add(option, "w3-disabled");

                    //domClass.remove(optionLabel, "mds-hover-dark");
                    //domClass.add(optionLabel, "w3-disabled");
                } else if (this.selectableAttribute != null && this.PitHelper.getEntityAttributeValue(entity, this.selectableAttribute) == true) {

                }

                var registryEntry = { value: value, entity: entity, optionNode: option, optionSelectorNode: optionSelector, label: label, visible: bShow, selected: this._selectedValues.indexOf(value, 0) != -1 };
                this.optionsRegistry.push(registryEntry);

                on(option, "click", lang.hitch(this, this._onClick_Option, registryEntry));


            }
        }

        if (bUpdateSelection !== false && bUpdateSelection !== true) {
            bUpdateSelection = true;
        }

        //this.set("value";
        this._adjustSelectionStyle();

        if (bUpdateSelection == true) {
            this.updateCurrentSelectedValues();
        }

        if (this.selectablesWithDropdown === true && this.dropdownAttributeName !== null) {

            this.optionsRegistry.forEach((option: any) => {

                let content = option.entity[`${this.dropdownAttributeName}`];
                let hoverNode = option.optionNode.lastChild;

                domClass.add(hoverNode, "w3-dropdown-hover");
                let hoverContent = domConstruct.create("div", {
                    class: "w3-dropdown-content w3-bar-block w3-border w3-padding-small w3-border-indigo w3-pale-yellow",
                    style: {
                        "pointer-events": "none",
                    },
                    innerHTML: content
                }, hoverNode);

                on(hoverNode, "mouseover", (evt: any) => {

                    let x = evt.clientX + 10;
                    let y = evt.clientY;

                    domStyle.set(hoverContent, {
                        position: "fixed",
                        top: `${y}px`,
                        left: `${x}px`
                    } as any);
                });
            });
        }
    }

    delayedHandleSearch(): void {
        if (this.__searchDelay != null) {
            clearTimeout(this.__searchDelay);
            this.__searchDelay = null;
        }

        this.__searchDelay = setTimeout(lang.hitch(this, this._handleSearch), 200);
    }


    _handleSearch(): void {

        this.__searchDelay = null;

        this._constructOptions(false);
    }


    updateCurrentSelectedValues(): void {
        this._selectedValues = [];
        this._selectedEntities = [];

        var textValue = "";

        for (var i = 0; i < this.optionsRegistry.length; i++) {
            var option = this.optionsRegistry[i];

            if (option.selected == true) {
                this._selectedValues.push(option.value);
                this._selectedEntities.push(option.entity);

                if (this._selectedValues.length > 1) {
                    textValue = textValue + ", ";
                }

                textValue = textValue + option.label;
            }
        }

        textValue = ("({0}) {1}" as any).format(this._selectedValues.length, textValue);

        this.outerInput.value = textValue;

    }

    _adjustSelectionStyle(targetOption?: any): void {
        var optionsList = this.optionsRegistry;

        if (typeof (targetOption) != "undefined") {
            optionsList = [targetOption];
        }

        var countVisible = 0;

        for (var i = 0; i < optionsList.length; i++) {
            var option = optionsList[i];
            option.selected = false;
            var iconHTML = iconHTML = "<i class='far fa-circle' aria-hidden='true'></i>";
            if (this._selectedValues.indexOf(option.value, 0) != -1) {
                iconHTML = "<i class='fas fa-check-circle' aria-hidden='true'></i>";
                option.selected = true;
            }

            if (option.visible == true) {
                countVisible++;
            }

            domAttr.set(option.optionSelectorNode, "innerHTML", iconHTML);
        }

        if (countVisible == 0) {
            domClass.remove(this.noResultsContainer, "w3-hide");
            domClass.add(this.scrollContainer, "w3-hide");
        } else {
            domClass.add(this.noResultsContainer, "w3-hide");
            domClass.remove(this.scrollContainer, "w3-hide");
        }
    }

    _setupEventListener(): void {

        //  click irgendwo im dokument schließt die vorschläge
        //
        document.addEventListener("click", lang.hitch(this, function (this: any, e: any) {
            this.toggleEditmode(false);
        }));

        on(this.domNode, "keyup", lang.hitch(this, function (e: any) {
            e.stopPropagation();
        }))

        on(this.domNode, "keydown", lang.hitch(this, function (e: any) {
            e.stopPropagation();
        }))

        on(this.domNode, "click", lang.hitch(this, function (e: any) {
            e.stopPropagation();
        }))
    }

    _onKeyDown_Input(evt: any): void {
        var x = this.scrollContainer;

        if (x) x = x.getElementsByTagName("div");
        if (evt.keyCode == 40) {
            this.currentFocus++;
            //this.addActive(x);
        } else if (evt.keyCode == 38) { //up
            this.currentFocus--;
            //this.addActive(x);
        } else if (evt.keyCode == 13) {
            evt.preventDefault();
            this.selectAll();
            if (this.currentFocus > -1) {
                //  focus auf item gesetzt
                //
                //if (x) x[this.currentFocus].click();
            } else {
                //  kein focus auf item
                //
                //if (x.length == 1) {
                //    x[0].click();
                //}
            }
        } else if (evt.keyCode == 27) { //esc
            if (this.input.value != false) {
                this.input.value = null;
                return;
            }
            this.set("editMode", false);
        }
    }

    // wenn ein Benutzer einen Hint auswählt, aber danach die Inputbox ändert, kann evtl ja die ganze Auswahl ungültig sein
    // deswegen einmalig ein Event auslösen
    _onKeyUp_Input(evt: any): void {

        this.delayedHandleSearch();
        evt.stopPropagation();
    }



    _onClick_OuterInput(evt?: any): void {
        // wenn möglich: bei Klick ins Eingabefeld gleich in den "Editiermodus" wechseln
        this.set("editMode", true);

    }

    _onClick_DropDown(evt?: any): void {
        this.toggleEditmode();
    }

    toggleEditmode(targetState?: any): void {

        if (typeof (targetState) == "undefined") {
            targetState = this.isEditModeActive !== true;
        }

        if (targetState === true) {
            this.set("editMode", true);
        } else {
            this.confirmSelection(false);
            this.set("editMode", false);
        }
    }

    setEditModeStyle(): void {
        var classFunc1: any = domClass.remove;
        var classFunc2: any = domClass.add;
        if (this.isEditModeActive == true) {
            classFunc1 = domClass.add;
            classFunc2 = domClass.remove;
        }

        //Anm: vom Normalfall "kein Editmodus" ausgehen:
        // classFunc2 fügt Klassen hinzu
        //
        classFunc2(this.dropdownContainer, "w3-hide");
        //classFunc1(this.outerInput, "w3-hide");

        if (this.isEditModeActive == true) {
            this.input.focus();
        }
    }

    _onClick_Option(option: any, evt?: any): void {
        if (this.readonly === true) {
            return;
        }

        this.selectOption(option, !option.selected);

    }

    selectOption(option: any, targetState: any): void {
        if (option.visible == true) {
            option.selected = targetState;
        }
        this.updateCurrentSelectedValues();
        this._adjustSelectionStyle(option);

        this.delayedConfirmSelection(false, 1888);

        //console.log("selectOption", option, this._selectedValues);
    }

    _onClick_ShowSelected(evt?: any): void {
        this.isShowSelectedMode = !this.isShowSelectedMode;

        this._constructOptions();

        if (this.isShowSelectedMode == true) {
            domClass.add(this.btnShowSelected, "accentcolor");
        } else {
            domClass.remove(this.btnShowSelected, "accentcolor");
        }
    }

    _onClick_Confirm(evt?: any): void {
        if (this.readonly === true) {
            return;
        }

        this.confirmSelection();
    }

    delayedConfirmSelection(bSuppressChange?: any, delay?: any): void {
        if (typeof (delay) != "number") {
            delay = 500;
        }

        if (this.__confirmDelay != null) {
            clearTimeout(this.__confirmDelay);
            this.__confirmDelay = null;
        }

        this.__confirmDelay = setTimeout(lang.hitch(this, this.confirmSelection, bSuppressChange), delay);
    }

    confirmSelection(bSuppressChange?: any): void {
        var oldValuestxt = this._oldSelection.toString();
        var newValuestxt = this._selectedValues.toString();
        if (this.__confirmDelay != null) {
            clearTimeout(this.__confirmDelay);
        }
        this.__confirmDelay = null;

        if (newValuestxt != oldValuestxt && bSuppressChange != true) {
            this.emit("change", this._selectedValues);
            //alert("new value: " + newValuestxt);
        }

        this._oldSelection = this._selectedValues;

        //this.set("editMode", false);
    }

    _onClick_SelectNone(evt?: any): void {
        if (this.readonly === true) {
            return;
        }

        for (var i = 0; i < this.optionsRegistry.length; i++) {
            this.selectOption(this.optionsRegistry[i], false);
        }
    }

    _onClick_SelectAll(evt?: any): void {
        if (this.readonly === true) {
            return;
        }

        this.selectAll();
    }

    selectAll(): void {
        for (var i = 0; i < this.optionsRegistry.length; i++) {
            this.selectOption(this.optionsRegistry[i], true);
        }
    }

    setAdditionalParameter(name: any, value: any): void {

        this.removeAdditionalParameter(name);

        this._additionalParameters.push({ name: name, value: value });

        //console.debug("hintbox addAdditionalParameter", name, value, this._additionalParameters);
    }

    removeAdditionalParameter(name: any): void {
        for (var i = 0; i < this._additionalParameters.length; i++) {
            if (this._additionalParameters[i].name == name) {
                this._additionalParameters.splice((window as any).index, 1); // JS2TS: `index` is undefined here in the original (should be `i`) — preserved as a latent bug.
                break;
            }
        }
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._additionalParameters = [];
        this._selectedValues = [];

        this.PitHelper._structureFormat = this.dataformat;

        this._setupEventListener();
        //this.checkValidity();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}
MultiSelectBox.prototype.declaredClass = 'JDM.MultiSelectBox';

export default mdsWidget(MultiSelectBox);
